module.exports = {
      id: "uae-usage",
      viewBox: "0 0 14 14",
      url: __webpack_public_path__ + "svg-sprite-a4f600bbb193d1259d8ec4877be13b3c.svg#uae",
      toString: function () {
        return this.url;
      }
    }